(function () {
  var ROOT_SELECTOR = '.ep-PDP-highlight';
  var READY_FLAG = 'epSliderReady';

  function EpHighlightSlider(root) {
    this.root = root;
    this.host = root.querySelector('slider-component');
    this.slider = root.querySelector('[id^="Slider-"]');
    this.progress = root.querySelector('.ep-slider-progress__bar');
    if (!this.host || !this.slider) return;

    this.frame = null;
    this.isStatic = null;
    this.onScroll = this.onScroll.bind(this);
    this.measure = this.measure.bind(this);

    this.slider.addEventListener('scroll', this.onScroll, { passive: true });

    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.slider);
    } else {
      window.addEventListener('resize', this.measure);
    }

    Array.prototype.forEach.call(this.slider.querySelectorAll('img'), function (image) {
      if (!image.complete) image.addEventListener('load', this.measure, { once: true });
    }, this);

    this.measure();
  }

  EpHighlightSlider.prototype.onScroll = function () {
    if (this.frame) return;
    this.frame = requestAnimationFrame(
      function () {
        this.frame = null;
        this.render();
      }.bind(this)
    );
  };

  EpHighlightSlider.prototype.measure = function () {
    var media = this.slider.querySelector('.multicolumn-card__image-wrapper .media');

    if (media) {
      var mediaRect = media.getBoundingClientRect();
      var hostRect = this.host.getBoundingClientRect();

      if (mediaRect.height > 0) {
        this.root.style.setProperty(
          '--ep-arrow-top',
          Math.round(mediaRect.top - hostRect.top + mediaRect.height / 2) + 'px'
        );
      }
    }

    this.render();
  };

  EpHighlightSlider.prototype.render = function () {
    var scrollable = this.slider.scrollWidth - this.slider.clientWidth > 2;

    if (this.isStatic !== !scrollable) {
      this.isStatic = !scrollable;
      this.root.classList.toggle('ep-slider--static', this.isStatic);
    }

    if (!this.progress) return;

    var ratio = scrollable
      ? (this.slider.scrollLeft + this.slider.clientWidth) / this.slider.scrollWidth
      : 1;

    this.progress.style.setProperty('--ep-progress', Math.min(1, Math.max(0, ratio)).toFixed(4));
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(ROOT_SELECTOR), function (root) {
      if (root.dataset[READY_FLAG]) return;
      root.dataset[READY_FLAG] = 'true';
      new EpHighlightSlider(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
